var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":_vm.categoryIconName,"src":`/img/categories/${_vm.categoryIcon}.svg`}})
}
var staticRenderFns = []

export { render, staticRenderFns }